import { gray07, gray55, gray80 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var MuiAvatar = {
    styleOverrides: {
        root: {
            fontSize: '0.625rem',
            height: rem(24),
            width: rem(24),
        },
        colorDefault: {
            border: "".concat(rem(1), " solid ").concat(gray55),
            backgroundColor: gray07,
            color: gray80,
        },
    },
};
